const isObject = (value: unknown): value is ObjectLiteral =>
  typeof value === `object` && !Array.isArray(value);
const isObjectArray = (value: unknown): value is ObjectLiteral[] =>
  Array.isArray(value) && value.every(isObject);

export { isObject, isObjectArray };
export default isObject;
